<template>
  <v-container>
    <v-card class='mb-4 green lighten-5'>
      <v-card-title>
        Rental price
      </v-card-title>
      <v-card-subtitle>
        Total price including all taxes, see specification below
      </v-card-subtitle>
      <v-card-text class='display-2 pb-1'>
        {{quotationData['prettyTotalPrice']}}
      </v-card-text>
      <v-card-actions>
        <v-btn @click="toFinalize()" class='ml-3 mt-0 mb-2 green white--text'>Confirm booking</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title>Specification</v-card-title>
      <v-card-text>
        <v-row dense v-for="(d,i) in showData" :key="`d_${i}`">
          <v-col md="2">{{d.caption}}</v-col>
          <v-col md="4" class='font-weight-bold'>{{lookupData(d)}}</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$store.commit('setStatus',0)" class='ma-3'>Edit</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class='mt-4'>
      <v-card-title>Your car</v-card-title>
      <v-card-text>
          <v-row dense v-for="(q,i) in showQuotation" :key="`q_${i}`">
            <v-col md="2">{{q.caption}}</v-col>
            <v-col md="4" class='font-weight-bold'>{{quotationData[q.dbName]}}</v-col>
          </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$store.commit('setStatus',0)" class='ma-3'>Edit</v-btn>
        <v-btn @click="toFinalize()" class='ma-3 green white--text'>Confirm booking</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

  import GlobalHelper from "../mixins/GlobalHelper"

  export default {
    name: 'Reservations',
    mixins: [GlobalHelper],
    data: () => ({
    }),
    mounted(){
    },
    methods:{
      toFinalize(){
        this.$store.commit('setUserQuotationData',this.quotationData);
        this.$store.commit('setStatus',2)
      },
      lookupData(entry){
        if(entry.dbLookupName){
          let d = this.$store.state.userData[entry.dbName][entry.dbLookupName]
          if(entry.date){
            return this.$moment(d).format('DD-MM-YYYY')
          }
          return d
        }
        if(entry.type=="date"){
          return this.$moment(this.$store.state.userData[entry.dbName]).format('DD-MM-YYYY')
        }
        return this.$store.state.userData[entry.dbName]
      }
    },
    computed:{
    },
    watch:{
    }
  }
</script>
